import React from 'react';
import { useReservations } from '../ReservationContext';

const ListView = ({ onOpenCreate, onOpenWalkIn, onEdit }) => {
  const {
    loading,
    reservations,
    selectedDate,
    setSelectedDate,
    statusFilter,
    setStatusFilter,
    stats,
    updateReservationStatus,
    cancelReservation,
    getStatusBadgeClass,
  } = useReservations();

  const handleSeat = (reservation) => {
    updateReservationStatus(reservation, 'seated');
  };

  const handleNoShow = (reservation) => {
    updateReservationStatus(reservation, 'no_show');
  };

  const handleComplete = (reservation) => {
    updateReservationStatus(reservation, 'completed');
  };

  const handleCancel = (reservation) => {
    if (window.confirm('Are you sure you want to cancel this reservation?')) {
      cancelReservation(reservation);
    }
  };

  return (
    <div className="reservations-list-view">
      {/* Filters and Actions */}
      <div className="list-toolbar">
        <div className="toolbar-left">
          <div className="date-picker-group">
            <label>Date:</label>
            <input
              type="date"
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
            />
          </div>
          <div className="filter-group">
            <label>Status:</label>
            <select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="all">All</option>
              <option value="confirmed">Confirmed</option>
              <option value="seated">Seated</option>
              <option value="completed">Completed</option>
              <option value="cancelled">Cancelled</option>
              <option value="no_show">No Show</option>
            </select>
          </div>
        </div>
        <div className="toolbar-right">
          <button className="btn btn-secondary" onClick={onOpenWalkIn}>
            Walk-In
          </button>
          <button className="btn btn-primary" onClick={onOpenCreate}>
            + Add Reservation
          </button>
        </div>
      </div>

      {/* Stats Cards */}
      {stats && (
        <div className="stats-row">
          <div className="stat-card">
            <div className="stat-value">{stats.total}</div>
            <div className="stat-label">Total</div>
          </div>
          <div className="stat-card stat-confirmed">
            <div className="stat-value">{stats.confirmed}</div>
            <div className="stat-label">Confirmed</div>
          </div>
          <div className="stat-card stat-seated">
            <div className="stat-value">{stats.seated}</div>
            <div className="stat-label">Seated</div>
          </div>
          <div className="stat-card stat-completed">
            <div className="stat-value">{stats.completed}</div>
            <div className="stat-label">Completed</div>
          </div>
          <div className="stat-card stat-covers">
            <div className="stat-value">{stats.total_covers}</div>
            <div className="stat-label">Active Covers</div>
          </div>
        </div>
      )}

      {/* Reservations Table */}
      <div className="reservations-table-wrapper">
        <table className="reservations-table">
          <thead>
            <tr>
              <th>Time</th>
              <th>Guest</th>
              <th>Party</th>
              <th>Phone</th>
              <th>Status</th>
              <th>Source</th>
              <th>Notes</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="8" className="loading-cell">Loading...</td>
              </tr>
            ) : reservations.length === 0 ? (
              <tr>
                <td colSpan="8" className="empty-cell">No reservations found</td>
              </tr>
            ) : (
              reservations.map((res) => (
                <tr key={res.reservation_id} className={`status-row-${res.status}`}>
                  <td className="time-cell">{res.reservation_time}</td>
                  <td className="guest-cell">
                    <div className="guest-name">{res.customer_name}</div>
                    {res.confirmation_code && (
                      <div className="confirmation-code">#{res.confirmation_code}</div>
                    )}
                  </td>
                  <td className="party-cell">{res.party_size}</td>
                  <td className="phone-cell">{res.customer_phone}</td>
                  <td>
                    <span className={getStatusBadgeClass(res.status)}>
                      {res.status}
                    </span>
                  </td>
                  <td className="source-cell">{res.source}</td>
                  <td className="notes-cell">{res.special_requests || '-'}</td>
                  <td className="actions-cell">
                    {res.status === 'confirmed' && (
                      <>
                        <button
                          className="action-btn seat-btn"
                          onClick={() => handleSeat(res)}
                          title="Seat"
                        >
                          Seat
                        </button>
                        <button
                          className="action-btn noshow-btn"
                          onClick={() => handleNoShow(res)}
                          title="No Show"
                        >
                          No Show
                        </button>
                      </>
                    )}
                    {res.status === 'seated' && (
                      <button
                        className="action-btn complete-btn"
                        onClick={() => handleComplete(res)}
                        title="Complete"
                      >
                        Complete
                      </button>
                    )}
                    {(res.status === 'confirmed' || res.status === 'seated') && (
                      <button
                        className="action-btn cancel-btn"
                        onClick={() => handleCancel(res)}
                        title="Cancel"
                      >
                        Cancel
                      </button>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ListView;
